// Copyright (c) StrangeBee 2024

import { Form } from 'antd';
import React, { ReactElement } from 'react';
import { WidgetGaugeOutput } from 'thehive-sdk';
import { useDashboard } from '@Hooks/useDashboard';
import WidgetDrawer from '@Organisms/Dashboard/WidgetManage/WidgetDrawer';
import { GaugeForm, GaugeValues } from '@Organisms/Dashboard/WidgetManage/Gauge/GaugeForm';
import { getNewGaugeWidget } from './NewGaugeDrawer';

interface GaugeDrawerProps {
    data: WidgetGaugeOutput;
}

const GaugeDrawer = ({ data }: GaugeDrawerProps): ReactElement => {
    const [form] = Form.useForm();
    const { editWidget } = useDashboard();

    const onFinish = (donut: GaugeValues): void => {
        const widgetId = data.id;
        const widgetGauge: WidgetGaugeOutput = {
            ...getNewGaugeWidget(donut),
            id: widgetId,
        };

        editWidget(widgetGauge, widgetId);
        form.resetFields();
    };

    return (
        <WidgetDrawer form={form} widgetType="donut">
            {(toggleDrawer, { setFieldsTouched }) => (
                <GaugeForm
                    form={form}
                    onFinish={(values) => {
                        onFinish(values);
                        toggleDrawer();
                    }}
                    onCancel={() => {
                        form.resetFields();
                        setFieldsTouched(false);
                        toggleDrawer();
                    }}
                    onChange={() => {
                        setFieldsTouched(true);
                    }}
                    defaultValues={data}
                />
            )}
        </WidgetDrawer>
    );
};

export default GaugeDrawer;
